import React from "react";
import PageItem from "./PageItem";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export default function Pagination({ currentPage, totalPages, onPageChange }: PaginationProps) {
  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;

    pageNumbers.push(
      <PageItem
        key="prev"
        label="<"
        isDisabled={isFirstPage}
        onPageChange={() => handlePageChange(currentPage - 1)}
      />,
    );

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - 2 && i <= currentPage + 2)) {
        pageNumbers.push(
          <PageItem
            key={i}
            label={i.toString()}
            isActive={i === currentPage}
            onPageChange={() => handlePageChange(i)}
          />,
        );
      }
      else if (i === currentPage - 3 || i === currentPage + 3) {
        pageNumbers.push(
          <PageItem
            key={`ellipsis-${i}`}
            label="..."
            isEllipsis={true}
            onPageChange={() => undefined}
          />,
        );
      }
    }

    pageNumbers.push(
      <PageItem
        key="next"
        label=">"
        isDisabled={isLastPage}
        onPageChange={() => handlePageChange(currentPage + 1)}
      />,
    );

    return pageNumbers;
  };

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination">
        {renderPageNumbers()}
      </ul>
    </nav>
  );
}
